import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, Inject, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { LeadUrlParameter } from 'src/app/models/user-data.models';
import { ApiService } from 'src/app/services/api.service';
// import { DateTime } from 'ts-luxon';

@Component({
  selector: 'fury-partners-add-edit',
  templateUrl: './partners-add-edit.component.html',
  styleUrls: ['./partners-add-edit.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class PartnersAddEditComponent implements OnInit {
  partnerForm!: FormGroup;
  parameter: LeadUrlParameter = { subId: false, clickId: false, traffic: false, keyword: false, position: false, gclid: false, fbclid: false, msclkid: false, twclid: false };
  partnerId: string = '';
  scriptMessage : string= ' Add Valid script tag (E.g. <script src="example.com"></script>).'
  constructor(private api: ApiService, private router: Router, private ar: ActivatedRoute, private _location: Location, public dialog: MatDialog, private _ngZone: NgZone) { }

  formControlItem: FormControl = new FormControl('');
 
  openFromIcon(timepicker: { open: () => void }) {
    timepicker.open();
  }
  onClear($event: Event) {
    this.formControlItem.setValue(null);
  }

  ngOnInit(): void {
    this.initForm()
    if (this.ar.snapshot.params['partnerId']) {
      this.partnerId = this.ar.snapshot.params['partnerId'];
      this.api.get('admin/lead-partner/get-lead-partner/' + this.partnerId).subscribe((data: HttpResponse<any>) => {
        if (data.status === 200) {
          const keyname: string[] = Object.keys(data.body['leadPartner'].data);
          this.initForm(data.body['leadPartner']);
          this.partnerForm.patchValue({
            isWebLead: data.body['leadPartner']?.isWebLead
          });
          this.validateField(data.body['leadPartner'].data, keyname);
        }
        else { this._location.back(); }
      })
    };
    this._ngZone.runOutsideAngular(() => {

    this.partnerForm.get('isWebLead')?.valueChanges.subscribe((res: any) => {      
      if (res) {
        this.partnerForm.get('utmSource')?.setValidators(Validators.required);
        this.partnerForm.get('phoneNumber')?.setValidators(Validators.required);
      } else {
        this.partnerForm.get('utmSource')?.clearValidators();
        this.partnerForm.get('phoneNumber')?.clearValidators();
      }
      this.partnerForm.controls['utmSource'].updateValueAndValidity();
      this.partnerForm.controls['phoneNumber'].updateValueAndValidity();
    });
    if (this.partnerForm.value.isWebLead) {
      this.partnerForm.get('utmSource')?.setValidators(Validators.required);
      this.partnerForm.get('phoneNumber')?.setValidators(Validators.required);
      this.partnerForm.controls['utmSource'].updateValueAndValidity();
      this.partnerForm.controls['phoneNumber'].updateValueAndValidity();
    }
  });
  }

  changeLead(event: any) {
    if (event.target.checked) {
      this.partnerForm.get('utmSource')?.setValidators(Validators.required);
      this.partnerForm.get('phoneNumber')?.setValidators(Validators.required);
    } else {
      this.partnerForm.get('utmSource')?.clearValidators();
      this.partnerForm.get('phoneNumber')?.clearValidators();
    }
    this.partnerForm.controls['utmSource'].updateValueAndValidity();
    this.partnerForm.controls['phoneNumber'].updateValueAndValidity();
  }

  initForm(data?: any) {
    this.partnerForm = new FormGroup({
      title: new FormControl((data?.title || ''), [Validators.required]),
      urlType: new FormControl((data ? (!data?.url.split('/')[3].startsWith('offers') ? 'estimates' : 'offers' || '') : ''), [Validators.required]),
      utmSource: new FormControl((data?.utmSource || ''),),
      apiKey: new FormControl((data?.apiKey || null), [Validators.required]),
      subId: new FormControl((data?.data?.subId || '')),
      phoneNumber: new FormControl((data?.phoneNumber || null), [Validators.pattern(/^[2-9][0-8]\d{1}[2-9]\d{2}\d{4}$/)]),
      data: new FormGroup({
        subId: new FormGroup({
          type: new FormControl((typeof (data?.data?.subId) === 'string' ? 'static': data?.data?.subId?.type || '')),
          value: new FormControl((typeof (data?.data?.subId) === 'object' ? data?.data?.subId?.value : data?.data?.subId || '')),
        }),
        clickId: new FormGroup({
          type: new FormControl((typeof (data?.data?.clickId) === 'string' ? 'static' : data?.data?.clickId?.type || '')),
          value: new FormControl((typeof (data?.data?.clickId) === 'object' ? data?.data?.clickId?.value : data?.data?.clickId || '')),
        }),
        traffic: new FormGroup({
          type: new FormControl((typeof (data?.data?.traffic) === 'string' ? 'static' : data?.data?.traffic?.type || '')),
          value: new FormControl((typeof (data?.data?.traffic) === 'object' ? data?.data?.traffic?.value : data?.data?.traffic || '')),
        }),
        keyword: new FormGroup({
          type: new FormControl((typeof (data?.data?.keyword)=== 'string' ? 'static' : data?.data?.keyword?.type || '')),
          value: new FormControl((typeof (data?.data?.keyword) === 'object' ? data?.data?.keyword?.value : data?.data?.keyword || '')),
        }),
        position: new FormGroup({
          type: new FormControl((typeof (data?.data?.position) === 'string' ? 'static' : data?.data?.position?.type || '')),
          value: new FormControl((typeof (data?.data?.position) === 'object' ? data?.data?.position?.value : data?.data?.position || '')),
        }),
        gclid: new FormGroup({
          type: new FormControl((typeof (data?.data?.gclid) === 'string' ? 'static' : data?.data?.gclid?.type || '')),
          value: new FormControl((typeof (data?.data?.gclid) === 'object' ? data?.data?.gclid?.value : data?.data?.gclid || '')),
        }),
        fbclid: new FormGroup({
          type: new FormControl((typeof (data?.data?.fbclid) === 'string' ? 'static' : data?.data?.fbclid?.type || '')),
          value: new FormControl((typeof (data?.data?.fbclid) === 'object' ? data?.data?.fbclid?.value : data?.data?.fbclid || '')),
        }),
        msclkid : new FormGroup({
          type: new FormControl((typeof (data?.data?.msclkid) === 'string' ? 'static' : data?.data?.msclkid?.type || '')),
          value: new FormControl((typeof (data?.data?.msclkid) === 'object' ? data?.data?.msclkid?.value : data?.data?.msclkid || '')),
        }),
        twclid : new FormGroup({
          type: new FormControl((typeof (data?.data?.twclid) === 'string' ? 'static' : data?.data?.twclid?.type || '')),
          value: new FormControl((typeof (data?.data?.twclid) === 'object' ? data?.data?.twclid?.value : data?.data?.twclid || '')),
        }),
      }),
      restrictedHours: new FormGroup({
        sunday: new FormGroup({
          startTime: new FormControl((data?.restrictedHours?.sunday?.startTime.slice(0, 5)),),
          endTime: new FormControl((data?.restrictedHours?.sunday?.endTime.slice(0, 5)))
        }),
        monday: new FormGroup({
          startTime: new FormControl((data?.restrictedHours?.monday?.startTime.slice(0, 5) ),),
          endTime: new FormControl((data?.restrictedHours?.monday?.endTime.slice(0, 5)))
        }),
        tuesday: new FormGroup({
          startTime: new FormControl((data?.restrictedHours?.tuesday?.startTime.slice(0, 5))),
          endTime: new FormControl((data?.restrictedHours?.tuesday?.endTime.slice(0, 5)))
        }),
        wednesday: new FormGroup({
          startTime: new FormControl((data?.restrictedHours?.wednesday?.startTime.slice(0, 5))),
          endTime: new FormControl((data?.restrictedHours?.wednesday?.endTime.slice(0, 5) ))
        }),
        thursday: new FormGroup({
          startTime: new FormControl((data?.restrictedHours?.thursday?.startTime.slice(0, 5))),
          endTime: new FormControl((data?.restrictedHours?.thursday?.endTime.slice(0, 5)))
        }),
        friday: new FormGroup({
          startTime: new FormControl((data?.restrictedHours?.friday?.startTime.slice(0, 5))),
          endTime: new FormControl((data?.restrictedHours?.friday?.endTime.slice(0, 5)))
        }),
        saturday: new FormGroup({
          startTime: new FormControl((data?.restrictedHours?.saturday?.startTime.slice(0, 5))),
          endTime: new FormControl((data?.restrictedHours?.saturday?.endTime.slice(0, 5)))
        }),
      }),
      type: new FormControl((data?.type || null)),
      cpl: new FormControl((data?.cpl || null)),
      thirdPartyWebhookUrl: new FormControl((data?.thirdPartyWebhookUrl || null)),
      scripts: new FormControl((data?.scripts || null), [Validators.pattern(/<script[^>]*src=['"][^'"]+['"][^>]*>[\s\S]*?<\/script>/i)]),
      referralAbbreviation: new FormControl((data?.referralAbbreviation || ''), [Validators.required, Validators.minLength(3), Validators.maxLength(7)]),
      isWebLead: new FormControl(true, [Validators.required])
    });
    this.parameter.subId = Boolean(typeof (data?.data?.subId) === 'object' ? data?.data?.subId?.type : data?.data?.subId);
    this.parameter.clickId = Boolean(typeof (data?.data?.clickId) === 'object' ? data?.data?.clickId?.type : data?.data?.clickId);
    this.parameter.traffic = Boolean(typeof (data?.data?.traffic) === 'object' ? data?.data?.traffic?.type : data?.data?.traffic);
    this.parameter.keyword = Boolean(typeof (data?.data?.keyword) === 'object' ? data?.data?.keyword?.type : data?.data?.keyword);
    this.parameter.position = Boolean(typeof (data?.data?.position) === 'object' ? data?.data?.position?.type : data?.data?.position);
    this.parameter.gclid = Boolean(typeof (data?.data?.gclid) === 'object' ? data?.data?.gclid?.type : data?.data?.gclid);
    this.parameter.fbclid = Boolean(typeof (data?.data?.fbclid) === 'object' ? data?.data?.fbclid?.type : data?.data?.fbclid);
    this.parameter.msclkid = Boolean(typeof (data?.data?.msclkid) === 'object' ? data?.data?.msclkid?.type : data?.data?.msclkid);
    this.parameter.twclid = Boolean(typeof (data?.data?.twclid) === 'object' ? data?.data?.twclid?.type : data?.data?.twclid);
  }
  convertTime(value: any){
    let [hours, minutes, seconds] = value.split(":");
    hours = parseInt(hours);
    let data: any;
// Checking if hours are 24
  if (hours === 24) {
    // Converting to "00:00:00"
    data = `00:${minutes}:${seconds}`;
   } else {
   data = value;
   }
    return data;
  }
  add(): void {
   
    if (this.partnerForm.valid) {
      const data = this.partnerForm.getRawValue();
    // ************  for Restricted hour section ***********
      if(data?.restrictedHours?.sunday?.startTime && data?.restrictedHours?.sunday?.endTime){
        if(data.restrictedHours.sunday.startTime.length === 5){
          data.restrictedHours.sunday.startTime = data?.restrictedHours?.sunday?.startTime + ':00';
        }
        if(data.restrictedHours.sunday.endTime.length === 5){
          data.restrictedHours.sunday.endTime = data?.restrictedHours?.sunday?.endTime + ':01';
        }
        data.restrictedHours.sunday.startTime = this.convertTime(data.restrictedHours.sunday.startTime);
        data.restrictedHours.sunday.endTime = this.convertTime(data.restrictedHours.sunday.endTime);

      } else {
        data.restrictedHours.sunday.startTime = '00:00:00';
        data.restrictedHours.sunday.endTime = '00:00:01';
      }
      if(data?.restrictedHours?.monday?.startTime && data?.restrictedHours?.monday?.endTime){
        if(data.restrictedHours.monday.startTime.length === 5){
          data.restrictedHours.monday.startTime = data?.restrictedHours?.monday?.startTime + ':00';
        }
        if(data.restrictedHours.monday.endTime.length === 5){
          data.restrictedHours.monday.endTime = data?.restrictedHours?.monday?.endTime + ':01';
        }
        data.restrictedHours.monday.startTime = this.convertTime(data.restrictedHours.monday.startTime);
        data.restrictedHours.monday.endTime = this.convertTime(data.restrictedHours.monday.endTime);
      } else {
        data.restrictedHours.monday.startTime = '00:00:00';
        data.restrictedHours.monday.endTime = '00:00:01';
      }
      if(data?.restrictedHours?.tuesday?.startTime && data?.restrictedHours?.tuesday?.endTime){
        if(data.restrictedHours.tuesday.startTime.length === 5){
          data.restrictedHours.tuesday.startTime = data?.restrictedHours?.tuesday?.startTime + ':00';
        }
        if(data.restrictedHours.tuesday.endTime.length === 5){
          data.restrictedHours.tuesday.endTime = data?.restrictedHours?.tuesday?.endTime + ':01';
        }
        data.restrictedHours.tuesday.startTime = this.convertTime(data.restrictedHours.tuesday.startTime);
        data.restrictedHours.tuesday.endTime = this.convertTime(data.restrictedHours.tuesday.endTime);
      } else {
        data.restrictedHours.tuesday.startTime = '00:00:00';
        data.restrictedHours.tuesday.endTime = '00:00:01';
      }
      if(data?.restrictedHours?.wednesday?.startTime && data?.restrictedHours?.wednesday?.endTime){
        if(data.restrictedHours.wednesday.startTime.length === 5){
          data.restrictedHours.wednesday.startTime = data?.restrictedHours?.wednesday?.startTime + ':00';
        }
        if(data.restrictedHours.wednesday.endTime.length === 5){
          data.restrictedHours.wednesday.endTime = data?.restrictedHours?.wednesday?.endTime + ':01';
        }
        data.restrictedHours.wednesday.startTime = this.convertTime(data.restrictedHours.wednesday.startTime);
        data.restrictedHours.wednesday.endTime = this.convertTime(data.restrictedHours.wednesday.endTime);
      } else {
        data.restrictedHours.wednesday.startTime = '00:00:00';
        data.restrictedHours.wednesday.endTime = '00:00:01';
      }
      if(data?.restrictedHours?.thursday?.startTime && data?.restrictedHours?.thursday?.endTime){
        if(data.restrictedHours.thursday.startTime.length === 5){
          data.restrictedHours.thursday.startTime = data?.restrictedHours?.thursday?.startTime + ':00';
        }
        if(data.restrictedHours.thursday.endTime.length === 5){
          data.restrictedHours.thursday.endTime = data?.restrictedHours?.thursday?.endTime + ':01';
        }
        data.restrictedHours.thursday.startTime = this.convertTime(data.restrictedHours.thursday.startTime);
        data.restrictedHours.thursday.endTime = this.convertTime(data.restrictedHours.thursday.endTime);
      } else {
        data.restrictedHours.thursday.startTime = '00:00:00';
        data.restrictedHours.thursday.endTime = '00:00:01';
      }
      if(data?.restrictedHours?.friday?.startTime && data?.restrictedHours?.friday?.endTime){
        if(data.restrictedHours.friday.startTime.length === 5){
          data.restrictedHours.friday.startTime = data?.restrictedHours?.friday?.startTime + ':00';
        }
        if(data.restrictedHours.friday.endTime.length === 5){
          data.restrictedHours.friday.endTime = data?.restrictedHours?.friday?.endTime + ':01';
        }
        data.restrictedHours.friday.startTime = this.convertTime(data.restrictedHours.friday.startTime);
        data.restrictedHours.friday.endTime = this.convertTime(data.restrictedHours.friday.endTime);
      } else {
        data.restrictedHours.friday.startTime = '00:00:00';
        data.restrictedHours.friday.endTime = '00:00:01';
      }
      if(data?.restrictedHours?.saturday?.startTime && data?.restrictedHours?.saturday?.endTime){
        if(data.restrictedHours.saturday.startTime.length === 5){
          data.restrictedHours.saturday.startTime = data?.restrictedHours?.saturday?.startTime + ':00';
        }
        if(data.restrictedHours.saturday.endTime.length === 5){
          data.restrictedHours.saturday.endTime = data?.restrictedHours?.saturday?.endTime + ':01';
        }
        data.restrictedHours.saturday.startTime = this.convertTime(data.restrictedHours.saturday.startTime);
        data.restrictedHours.saturday.endTime = this.convertTime(data.restrictedHours.saturday.endTime);
      } else {
        data.restrictedHours.saturday.startTime = '00:00:00';
        data.restrictedHours.saturday.endTime = '00:00:01';
      }

      // ******** for Data section **********
      if(!data?.data?.keyword?.type){
        delete data?.data?.keyword;
      } else if(!data?.data?.keyword?.value){
        delete data?.data?.keyword?.value;
      }
      if(!data?.data?.subId?.type){
        delete data?.data?.subId;
      } else if(!data?.data?.subId?.value){
        delete data?.data?.subId?.value
      }
      if(!data?.data?.clickId?.type){
        delete data?.data?.clickId;
      } else if(!data?.data?.clickId?.value){
        delete data.data?.clickId.value;
      }
      if(!data?.data?.traffic?.type){
        delete data?.data?.traffic;
      } else if(!data?.data?.traffic?.value){
        delete data?.data?.traffic?.value;
      }
      if(!data?.data?.position?.type){
        delete data?.data?.position;
      } else if(!data?.data?.position?.value){
        delete data?.data?.position?.value;
      }
      if(!data?.data?.gclid?.type){
        delete data?.data?.gclid;
      } else if(!data?.data?.gclid?.value){
        delete data?.data?.gclid?.value;
      }
      if(!data?.data?.fbclid?.type){
        delete data?.data?.fbclid;
      } else if(!data?.data?.fbclid?.value){
        delete data?.data?.fbclid?.value;
      }

      if(!data?.data?.msclkid ?.type){
        delete data?.data?.msclkid ;
      } else if(!data?.data?.msclkid ?.value){
        delete data?.data?.msclkid ?.value;
      }
      if(!data?.data?.twclid ?.type){
        delete data?.data?.twclid ;
      } else if(!data?.data?.twclid ?.value){
        delete data?.data?.twclid ?.value;
      }
      
      data.url = 'https://www.elitehw.com/' + this.partnerForm.controls['urlType'].value.toLowerCase() +'?utm_source=' +
      this.partnerForm.controls['utmSource'].value.toLowerCase() + (this.partnerForm.get('type')?.value ? '&medium='+ this.partnerForm.get('type')?.value : '') + 
      (( this.partnerForm.controls['data'].get('subId')?.value?.type === 'third-party') ? '&subid=' : '') +
      (( this.partnerForm.controls['data'].get('clickId')?.value?.type === 'third-party') ? '&clickid=' : '') +
      (( this.partnerForm.controls['data'].get('traffic')?.value?.type === 'third-party') ?  '&traffictype=' : '') + 
      (( this.partnerForm.controls['data'].get('keyword')?.value?.type === 'third-party') ? '&keyword=' : '') +
      (( this.partnerForm.controls['data'].get('position')?.value?.type === 'third-party') ? '&position=' : '') + 
      (( this.partnerForm.controls['data'].get('gclid')?.value?.type === 'third-party') ? '&gclid=' : '') + 
      (( this.partnerForm.controls['data'].get('fbclid')?.value?.type === 'third-party') ? '&fbclid=' : '') +
      (( this.partnerForm.controls['data'].get('msclkid')?.value?.type === 'third-party') ? '&msclkid=' : '') + 
      (( this.partnerForm.controls['data'].get('twclid')?.value?.type === 'third-party') ? '&twclid=' : '')
      Object.keys(data.data).map(key => { delete data[key] });
      const x = (this.partnerId) ? this.api.patch(`admin/lead-partner/update-lead-partner/${this.partnerId}`, data) : this.api.post('admin/lead-partner/create-lead-partner', data);
      x.subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.status === 200 || res.status === 201) {
            this.api.alert(res.body.message, 'success');
            this._location.back();
          } else {
            this.api.alert(res.body.message, 'warning');
          }
        }, error: (err) => {
          if (err) {
            this.api.alert(err?.message, 'error');
            if (err?.errors?.phoneNumber) {
              this.partnerForm.controls['phoneNumber'].setErrors({ notValid: true });
            }
          }
        }
      });
    } else {
      this.partnerForm.markAllAsTouched();
    }
  }

  updateValue(key: string, event: any) {
    if (event.checked) {
      const dialogRef = this.dialog.open(SelectParameterTypeDialog, {
        data: {},
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.partnerForm.controls['data']?.get(key)?.get('type')?.setValue(result.type);
          if (result.type === 'static') {
            this.partnerForm.controls['data']?.get(key)?.get('value')?.setValidators(Validators.required);
            this.partnerForm.controls['data']?.get(key)?.get('value')?.updateValueAndValidity();
            this.parameter[key as keyof LeadUrlParameter] = true;
          } else if (result.type === 'third-party') {
            this.partnerForm.controls['data']?.get(key)?.get('value')?.clearValidators();
            this.partnerForm.controls['data']?.get(key)?.get('value')?.updateValueAndValidity();
            this.parameter[key as keyof LeadUrlParameter] = true;
          } else if (result.type === 'dynamic') {
            this.partnerForm.controls['data']?.get(key)?.get('value')?.clearValidators();
            this.partnerForm.controls['data']?.get(key)?.get('value')?.updateValueAndValidity();
            this.parameter[key as keyof LeadUrlParameter] = true;
          }
        }
      });
    } else {
      this.partnerForm.controls['data']?.get(key)?.get('type')?.setValue(null);
      this.partnerForm.controls['data']?.get(key)?.get('value')?.setValue(null);
      this.partnerForm.controls['data']?.get(key)?.get('value')?.clearValidators();
      this.partnerForm.controls['data']?.get(key)?.get('value')?.updateValueAndValidity();
    }
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(SelectParameterTypeDialog, {
      data: {},
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  isNumberKey(evt: any) {
    const currencyFormat = /^\d+(\.\d{1,2})?$/;
    if (currencyFormat.test(evt.key) !== true) {
      return false;
    }
    return true;
  }

  generateRandomApiKey() {
    this.partnerForm.patchValue({ apiKey: (Math.random() + 1).toString(16).substring(7) });
  }
  validateField(data: any, fieldName:string[]){
    fieldName.forEach((key: any) => {
      if(data[key]?.type === 'static'){
        this.partnerForm.controls['data']?.get(key)?.get('value')?.setValidators(Validators.required);
        this.partnerForm.controls['data']?.get(key)?.get('value')?.updateValueAndValidity();
      }
    })
  }

}

@Component({
  selector: 'select-parameter-type',
  templateUrl: 'select-parameter-type.html',
})
export class SelectParameterTypeDialog {
  type = '';

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  submit() {
    this.dialogRef.close({ type: this.type });
  }
}
